var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAflacAccountLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6114 31.4399H0.166992V28.6528H33.6114V31.4399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7085 0.782471H32.2178V30.0464H29.4307V3.56951H15.4955V30.0464H12.7085V0.782471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56055 9.14355H14.1022V11.9306H4.34758V30.0463H1.56055V9.14355Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.6763,
    y: 6.35645,
    width: 5.57407,
    height: 2.78704,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6768,
    y: 11.9307,
    width: 5.57407,
    height: 2.78704,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6768,
    y: 17.5046,
    width: 5.57407,
    height: 2.78704,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6768,
    y: 23.0789,
    width: 5.57407,
    height: 2.78704,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAflacAccountLogoWhite);
export default __webpack_public_path__ + "static/media/aflac-account-logo-white.cedf34b337b618461a82e96c0618db1d.svg";
export { ForwardRef as ReactComponent };